import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import {CompanySandbox} from '../../../global';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import { PageContainerComponent } from '../../components/page-container/page-container.component';
import { TitledCardComponent } from '../../components/titled-card/titled-card.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'slm-aggreg8-package',
    templateUrl: './aggreg8-package.container.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PageContainerComponent, TitledCardComponent, SvgIconComponent, AsyncPipe, TranslatePipe]
})
export class Aggreg8PackageContainer implements OnInit {
  private companySandbox = inject(CompanySandbox);

  public companyName$: Observable<string>;

  ngOnInit(): void {
    this.companyName$ = this.companySandbox.activeCompany$.pipe(
      map(company => company?.partnerName ? company.partnerName : '')
    );
  }
}
